/* CRO21-I3 (2026-09-24): product card colour logic, moved out of snippets/product-card.liquid so it is
   downloaded once instead of being printed in every card. Loaded as a module, so it runs once per page
   even though every card references it. Behaviour is the same as the CRO-07 inline script, plus:
   - a colour whose price and sizes match what the card already shows has no template; the card's
     original price and sizes are used instead;
   - the variant link is built from the card link instead of a per-colour data-variant-url;
   - on load the images are only swapped when the selected colour shows a different photo.
   DEV-138 (2026-09-24): a swapped photo gets a responsive srcset (Shopify &width=) and keeps the
   card's sizes, instead of the original upload (1638x2048, ~90 KB each on a phone). */
const plp = window.__lmPlpCardVariant || (window.__lmPlpCardVariant = {});

if (!plp.ready) {
  plp.ready = true;

  const samePath = (a, b) => {
    try {
      return new URL(a, location.href).pathname === new URL(b, location.href).pathname;
    } catch (error) {
      return false;
    }
  };

  const cardWidths = [200, 300, 400, 500, 600, 700, 800, 1000, 1200];

  const setCardImage = (image, media) => {
    const src = media.preview_image.src;
    const joiner = src.includes('?') ? '&' : '?';
    const maxWidth = media.preview_image.width || cardWidths[cardWidths.length - 1];
    const widths = cardWidths.filter((width) => width <= maxWidth);

    if (!widths.length) {
      widths.push(maxWidth);
    }

    image.srcset = widths.map((width) => src + joiner + 'width=' + width + ' ' + width + 'w').join(', ');
    image.src = src + joiner + 'width=' + widths[Math.min(2, widths.length - 1)];

    if (media.preview_image.width && media.preview_image.height) {
      image.width = media.preview_image.width;
      image.height = media.preview_image.height;
    }

    if (media.alt) {
      image.alt = media.alt;
    }
  };

  const updateCardVariant = (card, option, initial) => {
    if (!option || !card.contains(option)) {
      return;
    }

    let media;
    let secondaryMedia;

    try {
      media = JSON.parse(option.dataset.variantMedia);
      secondaryMedia = option.dataset.variantSecondaryMedia ? JSON.parse(option.dataset.variantSecondaryMedia) : null;
    } catch (error) {
      return;
    }

    const primaryImage = card.querySelector('.product-card__image--primary');

    if (!primaryImage || !media?.preview_image?.src) {
      return;
    }

    if (!initial || !samePath(primaryImage.currentSrc || primaryImage.src, media.preview_image.src)) {
      setCardImage(primaryImage, media);

      const secondaryImage = card.querySelector('.product-card__image--secondary');

      if (secondaryImage && secondaryMedia?.preview_image?.src) {
        setCardImage(secondaryImage, secondaryMedia);
      }
    }

    if (card.dataset.plpColorSelection !== 'true') {
      return;
    }

    const variantId = option.dataset.variantId || '';

    if (variantId) {
      card.querySelectorAll('.product-card__figure > a, .product-card__title a').forEach((link) => {
        const url = new URL(link.href, location.href);
        url.searchParams.set('variant', variantId);
        link.href = url.pathname + url.search + url.hash;
      });
    }

    const presentation = card.querySelector('template[data-variant-id="' + CSS.escape(variantId) + '"]');
    const fallback = card.__lmPlpDefault || {};
    const nextPrice = presentation ? presentation.content.querySelector('price-list') : fallback.price;
    const nextSizes = presentation ? presentation.content.querySelector('.product-card__available-sizes') : fallback.sizes;
    const currentPrice = card.querySelector('.product-card__info > .v-stack > price-list');
    const currentSizes = card.querySelector('.product-card__info > .v-stack > .product-card__available-sizes');

    if (currentPrice && nextPrice) {
      currentPrice.replaceWith(nextPrice.cloneNode(true));
    }

    if (currentSizes && nextSizes) {
      currentSizes.replaceWith(nextSizes.cloneNode(true));
    }
  };

  const updateCardMedia = (event) => {
    const card = event.target.closest ? event.target.closest('product-card') : null;

    if (!card || card.dataset.plpColorMediaBound !== 'true') {
      return;
    }

    const label = event.target.closest('label[for]');
    const option = event.target.closest('input[data-variant-media]') || (label ? card.querySelector('#' + CSS.escape(label.htmlFor)) : null);

    updateCardVariant(card, option, false);
  };

  document.addEventListener('click', updateCardMedia);
  document.addEventListener('change', updateCardMedia);

  plp.init = (card) => {
    if (!card || card.dataset.plpColorMediaBound === 'true') {
      return;
    }

    card.dataset.plpColorMediaBound = 'true';

    if (card.dataset.plpColorSelection === 'true') {
      const price = card.querySelector('.product-card__info > .v-stack > price-list');
      const sizes = card.querySelector('.product-card__info > .v-stack > .product-card__available-sizes');

      card.__lmPlpDefault = {
        price: price ? price.cloneNode(true) : null,
        sizes: sizes ? sizes.cloneNode(true) : null
      };

      const selectedVariantId = card.dataset.plpSelectedVariant || '';
      const selectedColorId = card.dataset.plpSelectedColor || '';
      const initialOption =
        (selectedVariantId && card.querySelector('input[data-variant-media][data-variant-id="' + CSS.escape(selectedVariantId) + '"]')) ||
        (selectedColorId && card.querySelector('input[data-variant-media][value="' + CSS.escape(selectedColorId) + '"]')) ||
        card.querySelector('input[data-variant-media]:checked') ||
        card.querySelector('input[data-variant-media]');

      if (initialOption) {
        initialOption.checked = true;
        updateCardVariant(card, initialOption, true);
      }
    }
  };

  const initAdded = (records) => {
    records.forEach((record) => {
      record.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) {
          return;
        }

        if (node.matches('product-card')) {
          plp.init(node);
        }

        node.querySelectorAll('product-card').forEach((card) => plp.init(card));
      });
    });
  };

  document.querySelectorAll('product-card').forEach((card) => plp.init(card));
  new MutationObserver(initAdded).observe(document.documentElement, { childList: true, subtree: true });
}
